import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import React, { useRef, useState } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { mongoDBDateParserToUSAFormat } from "../../../../../../../../../utils/commonFunctions/date";

const ExplanationOfBenefitsGrid = ({ eligibleMembers, claimTotal }: any) => {
	const totalData =
		claimTotal && claimTotal.length > 0
			? [
					{
						DESCR: "Total",
						INCFRMDT: claimTotal[0]["INCFRMDT"],
						INCTODT: "",
						CHGAMT: claimTotal[0]["SUM(D.CHGAMT)"],
						"(D.EERESP-(D.DEDAMT+D.COPAMT+D.COINAMT))": 0,
						PRVRESP: claimTotal[0]["SUM(D.PRVRESP)"],
						ADJCVRD: claimTotal[0]["SUM(D.ADJCVRD)"],
						EXPLCD01: 13,
						COPAMT: claimTotal[0]["SUM(D.COPAMT)"],
						DEDAMT: claimTotal[0]["SUM(D.DEDAMT)"],
						PERC: claimTotal[0]["TOTAL_NOT_COVERED"],
						PLNRESP: claimTotal[0]["SUM(D.PLNRESP)"]
					}
			  ]
			: [];
	const [gridHeight, setGridHeight] = useState("400px");
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleDateCellRenderer = ({ value }: { value: string }) => {
		if (value) {
			// console.log("====>value", value);
			return mongoDBDateParserToUSAFormat(value);
		}
		return "NA";
	};

	return (
		<div className="explanation-of-benefits-grid" id="explanation-of-benefits-grid">
			<div className="ag-grid-main-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={eligibleMembers}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						pinnedBottomRowData={totalData}
						animateRows
						paginationPageSize={6}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						enableCellChangeFlash={true}
						defaultColGroupDef={{ marryChildren: true }}
						frameworkComponents={{ handleDateCellRenderer }}
						rowSelection={"single"}
					>
						<AgGridColumn
							field="DESCR"
							headerName="TYPE OF SERVICE"
							suppressSizeToFit
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="INCFRMDT"
							headerName="DATE OF SERVICE"
							suppressSizeToFit
							cellRenderer="handleDateCellRenderer"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="CHGAMT"
							headerName="TOTAL CHARGE"
							suppressSizeToFit
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							headerName="NOT COVERED OR PENALTY"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
							valueGetter={(params: any) => {
								const data = params.data;
								return data["(D.EERESP-(D.DEDAMT+D.COPAMT+D.COINAMT))"];
							}}
						></AgGridColumn>
						<AgGridColumn
							field="PRVRESP"
							headerName="DISCOUNT"
							suppressSizeToFit
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="ADJCVRD"
							headerName="ELIGIBLE EXPENSE"
							suppressSizeToFit
							filter={false}
						></AgGridColumn>
						<AgGridColumn
							field="EXPLCD01"
							headerName="REMARK CODE"
							suppressSizeToFit
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="COPAMT"
							headerName="CO-PAY"
							suppressSizeToFit
							filter={false}
						></AgGridColumn>
						<AgGridColumn
							field="DEDAMT"
							headerName="DEDUCTIBLE AMOUNT"
							suppressSizeToFit
							filter={false}
						></AgGridColumn>
						<AgGridColumn
							field="PERC"
							headerName="PAID AT %"
							suppressSizeToFit
							filter={false}
						></AgGridColumn>
						<AgGridColumn
							field="PLNRESP"
							headerName="BENEFITS PAID"
							suppressSizeToFit
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

export default ExplanationOfBenefitsGrid;
